import { gaugeService } from "services";
import { homeConstants } from "../constants";

export const gaugeActions = {
  getCopayPrice,
  getCouponPrice,
  getCouponPriceForCopayCardPrescription,
  updateCouponPrice,
  updateLowestCouponPrice,
  getAlternateList,
  getBrandDetailsNew,
  getGenericList,
  getGenericDetails,
  resetGenericDetails,
  resetBrandDetails,
  getPharmacyGroup,
  copayPriceReset,
  couponPriceReset,
};

function copayPriceReset() {
  return (dispatch) => {
    return dispatch({ type: homeConstants.COPAY_PRICE_RESET });
  };
}

function couponPriceReset() {
  return (dispatch) => {
    return dispatch({ type: homeConstants.COUPON_PRICE_RESET });
  };
}

function getCopayPrice(params) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getCopayPrice(params).then(
      (response) => {
        dispatch(success(response));
        dispatch(couponPriceReset());
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.COPAY_PRICE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.COPAY_PRICE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.COPAY_PRICE_FAILURE, error };
  }
}

function updateCouponPrice(data) {
  return (dispatch) => {
    return dispatch({ type: homeConstants.COUPON_PRICE_UPDATE, data });
  };
}

function updateLowestCouponPrice(data) {
  return (dispatch) => {
    return dispatch({ type: homeConstants.COUPON_PRICE_LOWEST_UPDATE, data });
  };
}

function getCouponPrice(params) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getCouponPrice(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.COUPON_PRICE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.COUPON_PRICE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.COUPON_PRICE_FAILURE, error };
  }
}

function getCouponPriceForCopayCardPrescription(params) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getCouponPriceForCopayCardPrescription(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.COUPON_PRICE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.COUPON_PRICE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.COUPON_PRICE_FAILURE, error };
  }
}

function getAlternateList(params) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getAlternateList(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.ALTERNATE_LIST_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.ALTERNATE_LIST_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.ALTERNATE_LIST_FAILURE, error };
  }
}


function getBrandDetailsNew(params) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getBrandDetailsNew(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.BRAND_DETAILS_REQUEST_NEW };
  }
  function success(response) {
    return { type: homeConstants.BRAND_DETAILS_SUCCESS_NEW, response };
  }
  function failure(error) {
    return { type: homeConstants.BRAND_DETAILS_FAILURE_NEW, error };
  }
}


function getGenericList(params, type) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getGenericList(params, type).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.GENERIC_LIST_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.GENERIC_LIST_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.GENERIC_LIST_FAILURE, error };
  }
}

function getGenericDetails(params) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getGenericDetails(params).then(
      (response) => {
        dispatch(success(response));
        dispatch(
          pharmacyList({
            data: response?.data?.favoritePharmacies,
          })
        );
      },
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.GENERIC_DETAILS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.GENERIC_DETAILS_SUCCESS, response };
  }
  function pharmacyList(response) {
    return { type: homeConstants.PHARMACY_GROUP_LIST_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.GENERIC_DETAILS_FAILURE, error };
  }
}

function resetGenericDetails() {
  return { type: homeConstants.RESET_GENERIC_DETAILS_DATA, data: {} };
}

function resetBrandDetails() {
  return { type: homeConstants.RESET_BRAND_DETAILS_DATA, data: {} };
}

function getPharmacyGroup(value) {
  return (dispatch) => {
    dispatch(request());
    gaugeService.getPharmacyGroup(value).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.PHARMACY_GROUP_LIST_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.PHARMACY_GROUP_LIST_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.PHARMACY_GROUP_LIST_FAILURE, error };
  }
}